import gsap from "gsap";

let lastScrollTop = 0;
window.addEventListener('scroll', e => {
    const y = window.scrollY
    const header = document.querySelector('header')

    const rect = header.getBoundingClientRect()
    if (y > rect.height + 20) {
        header.classList.add('hidden')
    } else {
        header.classList.remove('hidden')
    }



    if (y > 300) {
        header.classList.add('add-background')
    } else {
        header.classList.remove('add-background')
    }





    if (y < lastScrollTop) {
        header.classList.remove('hidden')
    }

    lastScrollTop = y

})



const heroBannerButton = () => {
    const buttons = document.querySelectorAll('.hero-banner .primary-button a')

    if (buttons) {
        buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                if (lenis) {
                    lenis.scrollTo(window.innerHeight)
                }
            })
        })
    }
}

const acnhorsNav = () => {
    const allLinks = document.querySelectorAll("a");

    const updateActiveLinks = (activeHash) => {
        allLinks.forEach(link => {
            const href = link.getAttribute("href");
            if (!href || !href.includes("#")) return;

            const hashPart = href.split("#")[1];

            if (`#${hashPart}` === activeHash) {
                link.classList.add("active");
            } else {
                link.classList.remove("active");
            }
        });
    };

    allLinks.forEach(link => {
        const href = link.getAttribute("href");
        if (!href || !href.includes("#")) return;

        const hashPart = href.split("#")[1];

        // Set active saat page load
        if (window.location.hash === `#${hashPart}`) {
            link.classList.add("active");
        }

        link.addEventListener("click", (e) => {
            e.preventDefault();

            const targetId = hashPart;
            const anchorTarget = document.getElementById(targetId);

            if (anchorTarget) {
                lenis.scrollTo(`#${targetId}`);
                history.pushState(null, "", `#${targetId}`);
                updateActiveLinks(`#${targetId}`);

                if (window.innerWidth < 600) {
                    lenis.start()
                    gsap.to(mobileMenu, {
                        clipPath: 'inset(0% 0% 100% 0%)',
                        duration: 1,
                        pointerEvents: 'none',
                        ease: 'power4.inOut',
                        onComplete: () => {
                            closeAllSubMenu()
                        }
                    })
                }
            } else {
                window.location.href = href;
            }
        });
    });


    window.addEventListener("hashchange", () => {
        updateActiveLinks(window.location.hash);
    });
};






const scrollAnchor = () => {
    window.scrollTo(0, 0);

    window.addEventListener("DOMContentLoaded", () => {
        const hash = window.location.hash;

        if (!hash) return

        // setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) {
            lenis.scrollTo(target);
        }
        // }, 1000);
    });

}


const navigationWithSub = () => {
    const subMenu = document.querySelectorAll('li.menu-item-has-children')

    if (subMenu) {
        subMenu.forEach(menu => {

            if (innerWidth > 800) {
                menu.addEventListener('mouseover', () => {
                    menu.classList.add('sub-active')
                })

                menu.addEventListener('mouseout', () => {
                    menu.classList.remove('sub-active')
                })
            } else {
                const buttonIcon = document.createElement('div')
                buttonIcon.classList.add('button-trigger')
                menu.appendChild(buttonIcon);


                buttonIcon.addEventListener('click', () => {
                    menu.classList.toggle('sub-active')
                })

            }
        })
    }

}


const closeAllSubMenu = () => {
    const subMenu = document.querySelectorAll('li.menu-item-has-children')
    if (subMenu) {
        subMenu.forEach(menu => {

            if (innerWidth < 800) {
                menu.classList.remove('sub-active')
            }
        })
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const burgerMenu = document.querySelector('.burger')
    const mobileMenu = document.querySelector('.mobile-menu')
    let menuActive = false

    if (burgerMenu) {
        burgerMenu.addEventListener('click', () => {

            burgerMenu.classList.toggle('active')

            if (!menuActive) {
                lenis.stop()
                gsap.to(mobileMenu, {
                    clipPath: 'inset(0% 0% 0% 0%)',
                    duration: .75,
                    pointerEvents: 'all',
                    ease: 'power4.inOut'
                })

            } else {
                lenis.start()
                gsap.to(mobileMenu, {
                    clipPath: 'inset(0% 0% 100% 0%)',
                    duration: .75,
                    pointerEvents: 'none',
                    ease: 'power4.inOut',
                    onComplete: () => {
                        closeAllSubMenu()
                    }
                })
            }

            menuActive = !menuActive
        })
    }


    heroBannerButton()

    acnhorsNav()


    navigationWithSub()

})



